import { IAppProps, IAppProviderState, REDUCER_KEY } from '../interface/IAppProvider';
import { getDataToObjectCache, sendDataToObjectCache } from '../async/AsyncCalls';
import { setSessionItem, getSessionItem } from '../services/StorageService';
import { TDispatch } from '../context/AppContext';

interface IObjectCacheResp {
    objectId: string;
}
export const saveToObjectCache = (props: IAppProps, state: IAppProviderState, appDispatch: TDispatch) => {
    appDispatch({ type: REDUCER_KEY.LOADING_DATA, payload: true });
    sendDataToObjectCache(props, appDispatch, { data: updateObject(state) }).then((response: IObjectCacheResp) => {
        if (response) {
            setSessionItem('onsa-b2b-session-key', response.objectId);
            appDispatch({ type: REDUCER_KEY.LOADING_DATA, payload: false });
            appDispatch({ type: REDUCER_KEY.SET_STATE_CHANGE, payload: false });
        } else {
            props.c9log.error(`Something went wrong in promise when trying to save the data to cache`, 'Actions');
            appDispatch({
                type: REDUCER_KEY.SET_ERROR,
                payload: { stepOne: true, stepTwo: false, separateCallMe: false },
            });
        }
    });
};

export const reloadApplicationStateFromCache = async (props: IAppProps, appDispatch: TDispatch) => {
    const key = getSessionItem('onsa-b2b-session-key');
    if (key) {
        getDataToObjectCache(props, appDispatch, key).then((response) => {
            if (response) {
                const stateFromObjectCache = response.object.data;
                appDispatch({ type: REDUCER_KEY.RELOAD_STATE, payload: stateFromObjectCache });
                appDispatch({ type: REDUCER_KEY.SET_INITIAL_STATE, payload: false });
                appDispatch({ type: REDUCER_KEY.SET_STATE_CHANGE, payload: false });
                appDispatch({ type: REDUCER_KEY.REFRESH_FROM_CACHE, payload: true });
            } else {
                appDispatch({
                    type: REDUCER_KEY.SET_ERROR,
                    payload: { stepOne: true, stepTwo: false, separateCallMe: false },
                });
            }
        });
    } else {
        appDispatch({ type: REDUCER_KEY.REFRESH_FROM_CACHE, payload: true });
    }
};

/**
 * Remove resource bundles
 */
export const updateObject = (globalState: IAppProviderState) => {
    const stateCopy = { ...globalState };
    //Match with initial state for browser refresh
    stateCopy.refreshFromCache = false;
    return stateCopy;
};
